'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = require('./throttle.js');

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavScrollSpy = function () {
	function NavScrollSpy(options) {
		_classCallCheck(this, NavScrollSpy);

		var defaults = {
			offset: 0,
			currentClass: 'active',
			selector: 'nav a[href*="#"]',
			throttle: 100
		};
		options ? this.options = Object.assign(defaults, options) : this.options = defaults;

		this.prevCurrentSections = [];
		this.navItems = {};
	}

	_createClass(NavScrollSpy, [{
		key: 'elOffsetTop',
		value: function elOffsetTop(el) {
			var top = 0;
			try {
				while (el.parentNode) {
					top += el.offsetTop;
					el = el.parentNode;
				}
				return top;
			} catch (err) {
				//#####################=> TODO
				console.warn('Section missing!', err);
			}
		}
	}, {
		key: 'getElements',
		value: function getElements() {
			// Nav Items
			var navItemsNodeList = document.querySelectorAll(this.options.selector);
			// Store nav items in object with hash-keys
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = navItemsNodeList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					this.navItems[item.hash] = item;
				}

				// Store Sections
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.sections = [];
			for (var key in this.navItems) {
				var section = document.querySelector(key);
				this.sections.push(section);
			}
		}
	}, {
		key: 'getSectionsParams',
		value: function getSectionsParams() {
			var _this = this;

			this.sectionsParams = [];
			this.sections.forEach(function (item, i) {
				var top = _this.elOffsetTop(item);
				_this.sectionsParams.push({ top: top, bottom: top + item.offsetHeight, id: '#' + item.id });
			});
		}
	}, {
		key: 'setCurentMenuItems',
		value: function setCurentMenuItems(sectionsInScreen) {
			var _this2 = this;

			// prevCurrentSections not available
			if (this.prevCurrentSections.length === 0) {
				// No items for cleaning and no new available
				if (sectionsInScreen.length === 0) {
					return;
				}
				// No items for cleaning and new available
				else {
						for (var key in sectionsInScreen) {
							var id = sectionsInScreen[key].id;
							this.navItems[id].parentNode.classList.add(this.options.currentClass);
						}
					}
			}
			// prevCurrentSections available
			else {
					// Available prevNavItems and new not available. Remove old. ( this.prevCurrentSections.length !== 0 && sectionsInScreen.length === 0 )
					if (sectionsInScreen.length === 0) {
						for (var _key in this.prevCurrentSections) {
							var _id = this.prevCurrentSections[_key].id;
							this.navItems[_id].parentNode.classList.remove(this.options.currentClass);
						}
					}
					// Available prevNavItems and new available, compare they
					else {
							Object.keys(this.navItems).forEach(function (key, i) {
								// Remove current class
								if (_this2.prevCurrentSections[i] && !sectionsInScreen[i]) {
									_this2.navItems[key].parentNode.classList.remove(_this2.options.currentClass);
								}
								// Add current class
								if (!_this2.prevCurrentSections[i] && sectionsInScreen[i]) {
									_this2.navItems[key].parentNode.classList.add(_this2.options.currentClass);
								}
								// Else available in both arrays and already have current class
							});
						}
				}

			// Store current sections
			this.prevCurrentSections = sectionsInScreen;
		}
	}, {
		key: 'defineCurrentSection',
		value: function defineCurrentSection() {
			var winScrollPos = window.pageYOffset + this.options.offset;
			var sectionsInScreen = [];
			this.sectionsParams.forEach(function (section, i) {
				if (winScrollPos > section.top && winScrollPos < section.bottom) sectionsInScreen[i] = section;
			});
			this.setCurentMenuItems(sectionsInScreen);
		}
	}, {
		key: 'setEvents',
		value: function setEvents() {
			// Throttling to improve performance
			var throttledDefineCurrentSection = (0, _throttle2.default)(this.defineCurrentSection, this.options.throttle).bind(this),
			    throttledGetSectionsParams = (0, _throttle2.default)(this.getSectionsParams, this.options.throttle).bind(this);

			// Scroll
			window.addEventListener('scroll', function () {
				return throttledDefineCurrentSection();
			});

			// Resize
			window.addEventListener('resize', function () {
				throttledGetSectionsParams();
				throttledDefineCurrentSection();
			});
		}
	}, {
		key: 'init',
		value: function init() {
			this.getElements();
			this.getSectionsParams();
			this.setEvents();
		}
	}]);

	return NavScrollSpy;
}();

exports.default = NavScrollSpy;